import ReactDOM from 'react-dom/client';
import App from './app';
import "./langsconfig/i18n";

import './assets/css/bootstrap.min.css';
import './assets/css/all.min.css';

import { loadScripts } from './utils/loadScripts';

loadScripts()
  .then(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<App />);
  })
  .catch((error) => {
    console.error('Failed to load required scripts:', error);
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<App />);
  });